export default __webpack_public_path__ + "static/media/logo-spora.8cde1794.png";